/* Land- og sprogvælger i bunden (snippets/localization-form.liquid).
   Filen manglede i temaet, så knappen kunne ikke åbnes. AKW 9/10 2026. */
(function () {
  if (customElements.get("localization-form")) return;

  var css = document.createElement("style");
  // !important: temaets sidefod farver listen mørk, så teksten ellers forsvinder.
  css.textContent =
    "localization-form .disclosure{position:relative;display:inline-block}" +
    "localization-form .disclosure__list{position:absolute!important;bottom:100%!important;left:0;z-index:50;margin:0 0 6px!important;padding:6px 0!important;" +
    "list-style:none;background:#fff!important;border:1px solid #ccc!important;min-width:100%;max-height:60vh;overflow-y:auto;box-shadow:0 4px 16px rgba(0,0,0,.15)}" +
    "localization-form .disclosure__item{background:#fff!important;margin:0!important}" +
    "localization-form .disclosure__item a{display:block!important;padding:8px 16px!important;color:#242424!important;background:#fff!important;opacity:1!important;text-decoration:none;white-space:nowrap}" +
    "localization-form .disclosure__item a:hover,localization-form .disclosure__item a[aria-current]{background:#f2ebce!important;color:#242424!important}";
  document.head.appendChild(css);

  customElements.define("localization-form", class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.knap = this.querySelector(".disclosure__button");
      this.liste = this.querySelector(".disclosure__list");
      this.felt = this.querySelector('input[name="country_code"], input[name="locale_code"]');
      if (!this.knap || !this.liste || !this.felt) return;
      this.knap.addEventListener("click", function () { self.vis(self.liste.hidden); });
      this.addEventListener("keyup", function (e) { if (e.key === "Escape") { self.vis(false); self.knap.focus(); } });
      document.addEventListener("click", function (e) { if (!self.contains(e.target)) self.vis(false); });
      this.querySelectorAll(".disclosure__item a").forEach(function (a) {
        a.addEventListener("click", function (e) {
          e.preventDefault();
          self.felt.value = a.dataset.value;
          self.querySelector("form").submit();
        });
      });
    }
    vis(aaben) {
      this.liste.hidden = !aaben;
      this.knap.setAttribute("aria-expanded", aaben ? "true" : "false");
    }
  });
})();
